// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-3ybN3";
var _3 = "icon-1Vo9i";
var _4 = "sunInfo__inner-1G4D8";
export { _1 as "__esModule", _2 as "wrapper", _3 as "icon", _4 as "sunInfo__inner" }
export default { "__esModule": _1, "wrapper": _2, "icon": _3, "sunInfo__inner": _4 }
